// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"765":"78e2c56c","799":"ef7a513d"}[chunkId] + ".chunk.js";
};